import React, { useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../styles/floatingForm.css';

const CreateLocationInPage = () => {
  const navigate = useNavigate();

  const [location, setLocation] = useState('');
  const [description, setDescription] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateImageDimensions = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.onload = () => {
        if (
          image.width <= maxWidth &&
          image.height <= maxHeight
        ) {
          resolve(true);
        } else {
          resolve(false);
        }

        URL.revokeObjectURL(image.src);
      };

      image.onerror = () => {
        reject(new Error('Invalid image file'));
      };

      image.src = URL.createObjectURL(file);
    });
  };


  // -----------------------------------
  // SUBMIT
  // -----------------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!location.trim()) {
      newErrors.location =
        'Location name cannot be empty';
    }

    if (!description.trim()) {
      newErrors.description =
        'Description cannot be empty';
    }

    const allowedImageTypes = [
      'image/png',
      'image/jpeg'
    ];

    if (!imageFile) {

      newErrors.imageFile =
        'Image cannot be empty, only PNG and JPG files are allowed';

    } else if (
      !allowedImageTypes.includes(imageFile.type)
    ) {

      newErrors.imageFile =
        'Only PNG and JPG files are allowed';

    } else {

      // If you want to enable image dimension validation,
      // uncomment this section.

      /*
      const isValidImage =
        await validateImageDimensions(
          imageFile,
          239,
          350
        );

      if (!isValidImage) {
        newErrors.imageFile =
          'Image must be under 239px by 350px';
      }
      */
    }


    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }


    setErrors({});
    setLoading(true);


    const formData = new FormData();

    formData.append(
      'location',
      location
    );

    formData.append(
      'description',
      description
    );

    if (imageFile) {
      formData.append(
        'banner_image_path',
        imageFile
      );
    }


    try {

      const response = await api.post(
        '/location/add',
        formData,
        {
          headers: {
            'Content-Type':
              'multipart/form-data',
          },
        }
      );


      if (
        response.data.status === 'success'
      ) {

        toast.success(
          'Location created successfully!'
        );

        // Go back to Location List
        navigate('/manage-location');

      } else {

        toast.error(
          response.data ||
          'Failed to create location. Please try again.'
        );

      }

    } catch (error) {

      console.error(
        'Error creating location:',
        error
      );

      toast.error(
        error.response?.data ||
        'Error creating location'
      );

    } finally {

      setLoading(false);

    }
  };


  // -----------------------------------
  // CANCEL
  // -----------------------------------

  const handleCancel = () => {

    setLocation('');
    setDescription('');
    setImageFile(null);
    setErrors({});

    navigate('/manage-location');
  };

  return (
    <div className='floating-form-container'  >
      <div className="heading">
        <h2>Vendor Details</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">
                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="name">Location Name *</label>
                        <input
                        type="text"
                        className={`form-control ${errors.location ? 'is-invalid' : ''}`}
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        placeholder="Enter location"
                        />
                        <b>{errors.location && <span className='text-danger small'>{errors.location}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label htmlFor="email">Description *</label>
                        <ReactQuill
                            value={description}
                            onChange={setDescription}
                            className={`react-quill ${errors.description ? 'is-invalid' : ''}`}
                            placeholder="Enter Description"
                        />
                        <b>{errors.description && <span className='text-danger small'>{errors.description}</span>}</b>
                    </div>

                    
                </div>

                <hr className='form-rule' />

                <div className="section-1">

                    <h2 className='wid-100'>Upload Image</h2>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="logo">Choose Location Image * <br /> (only PNG and JPG size 239px*350px)</label>
                        
                        <div class="file-select">
                            <div class="file-select-button" id="fileName">Choose File</div>
                            <div class="file-select-name" id="noFile">{imageFile?.name || "No file chosen..."}</div> 
                            <input type="file" id="logo" onChange={(e) => setImageFile(e.target.files[0])} />
                        </div>
                            <b>{errors.imageFile && <span className="text-danger small">{errors.imageFile}</span>}</b>

                    </div>
                </div>

            </div>

            <div className="form-btn-container">

                <button type='submit'>Create</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>


        </form>

    </div>
  );
};

export default CreateLocationInPage;
